import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M15.279 7.677a1 1 0 0 1 1.396.225 7 7 0 0 1 .016 8.173 1 1 0 0 1-1.626-1.164 5 5 0 0 0-.011-5.838 1 1 0 0 1 .225-1.396",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M18.039 4.826a1 1 0 0 1 1.408.128 11 11 0 0 1-.041 14.141 1 1 0 0 1-1.528-1.29 9 9 0 0 0 .033-11.57 1 1 0 0 1 .127-1.409M7.617 3.076a1 1 0 0 1 1.09.217l4 4a1 1 0 0 1 0 1.414L9.414 12l3.293 3.293a1 1 0 0 1 0 1.414l-4 4A1 1 0 0 1 7 20v-5.586l-2.293 2.293a1 1 0 1 1-1.414-1.414L6.586 12 3.293 8.707a1 1 0 0 1 1.414-1.414L7 9.586V4a1 1 0 0 1 .617-.924M9 14.414 10.586 16 9 17.586zm0-4.828V6.414L10.586 8z",
      clipRule: "evenodd"
    }
  )
);
var SvgBluetoothOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var BluetoothOutlined_default = SvgBluetoothOutlined;

export { BluetoothOutlined_default as default };
